export default "__VITE_ASSET__BzO33UAJ__"